export default "__VITE_ASSET__CtG8G6Dg__"